import { Info, SealCheck } from "@phosphor-icons/react";
import { toast } from "react-toastify";

import Switch from "common/components/ui/Switch";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";

import useAccountPreferences from "../../datahooks/useAccountPreferences";
import useAccountPreferencesMutations from "../../datahooks/useAccountPreferencesMutations";
import DetailItem from "./DetailItem";

interface AutoAcceptConnectionsRowProps {
  accountId: string;
}

export default function AutoAcceptConnectionsRow({
  accountId,
}: AutoAcceptConnectionsRowProps) {
  const { permissions } = useSelectedWorkspaceContext();
  const { preferences, isLoadingPreferences } =
    useAccountPreferences(accountId);
  const { updateAccountPreferences } = useAccountPreferencesMutations();

  const isViewOnly = !permissions.includes("accounts_full");

  return (
    <DetailItem
      label="Auto accept connections"
      tooltip={
        <Tooltip>
          <TooltipTrigger>
            <Info weight="fill" size={16} className="fill-black-300" />
          </TooltipTrigger>

          <TooltipContent className="text-center">
            Automatically accept all incoming connection requests on this
            account. This is a global setting, unrelated to campaigns.
          </TooltipContent>
        </Tooltip>
      }
      icon={<SealCheck weight="fill" />}
    >
      <Switch
        checked={preferences?.autoaccept ?? false}
        disabled={isViewOnly || isLoadingPreferences}
        onCheckedChange={(checked) => {
          updateAccountPreferences({ accountId, autoaccept: checked }).catch(
            () => toast.error("Error updating preferences"),
          );
        }}
      />
    </DetailItem>
  );
}
